/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isuserallowedtoaccesscamerasettings6Inputs */

const en_entity_isuserallowedtoaccesscamerasettings6 = /** @type {(inputs: Entity_Isuserallowedtoaccesscamerasettings6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is User Allowed To Access Camera Settings`)
};

const de_entity_isuserallowedtoaccesscamerasettings6 = /** @type {(inputs: Entity_Isuserallowedtoaccesscamerasettings6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer darf Kameraeinstellungen öffnen`)
};

/**
* | output |
* | --- |
* | "Is User Allowed To Access Camera Settings" |
*
* @param {Entity_Isuserallowedtoaccesscamerasettings6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isuserallowedtoaccesscamerasettings6 = /** @type {((inputs?: Entity_Isuserallowedtoaccesscamerasettings6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isuserallowedtoaccesscamerasettings6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isuserallowedtoaccesscamerasettings6(inputs)
	return de_entity_isuserallowedtoaccesscamerasettings6(inputs)
});
export { entity_isuserallowedtoaccesscamerasettings6 as "entity_isUserAllowedToAccessCameraSettings" }